import { useQuery } from "@tanstack/react-query";

import { httpClient } from "@/lib/http";
import { HttpResponse, VerifyInvitationResponse } from "@/types";

export function useVerifyInvitation({ token }: { token: string }) {
  return useQuery({
    queryKey: ["join", token],
    queryFn: async () => {
      const path = `join/${token}`;
      const res = await httpClient.get<
        VerifyInvitationResponse,
        HttpResponse<VerifyInvitationResponse>
      >(path, {
        // So that the cookie is sent with the request.
        withCredentials: true,
      });
      return res.data;
    },
  });
}
